// «Quando succede» con un promemoria di Google Calendar (0.1.40): il giro parte quando un
// appuntamento sta per iniziare, uno per appuntamento. Stessa connessione Google della posta.
import type { ReactNode } from 'react';
import { Banner } from '../../components/Banner';
import { Field, TextField } from '../../components/Field';
import { Select } from '../../components/Select';
import type { RoutineCondition } from '../../lib/api';

const BEFORE = [5, 10, 15, 30, 60, 120, 1440];
const before = (m: number) =>
  m < 60
    ? `${m} minuti prima`
    : m === 60
      ? '1 ora prima'
      : m === 1440
        ? '1 giorno prima'
        : `${m / 60} ore prima`;

export function CalendarFields({
  value,
  set,
  everySelect,
}: {
  value: RoutineCondition;
  set: (patch: Partial<RoutineCondition>) => void;
  everySelect: ReactNode;
}) {
  return (
    <>
      <div className="rw-grid">
        <Field
          label="Quanto prima"
          hint="Il giro parte quando l’appuntamento inizia entro questo tempo."
        >
          <Select
            label="Quanto prima dell’inizio"
            value={String(value.minutes_before ?? 15)}
            onChange={(v) => set({ minutes_before: Number(v) })}
            options={BEFORE.map((m) => ({ value: String(m), label: before(m) }))}
            width="100%"
          />
        </Field>
        <Field label="Calendario" hint="«primary» è il calendario principale dell’account.">
          <TextField
            value={value.calendar ?? 'primary'}
            onChange={(calendar) => set({ calendar })}
            mono
          />
        </Field>
        <Field label="Solo se contiene" hint="Facoltativo: testo da cercare negli appuntamenti.">
          <TextField value={value.query ?? ''} onChange={(query) => set({ query })} />
        </Field>
        {everySelect}
      </div>
      <Banner kind="info">
        Un giro per appuntamento, con titolo, orario, luogo e descrizione nel compito. Un invito può
        venire da fuori: il testo arriva al pop come dato non fidato. PopTown ricorda gli
        appuntamenti già fatti; uno spostato vale di nuovo.
      </Banner>
    </>
  );
}
